import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DemoCard.css';

function DemoCard({ title, description, icon, route, tags, status }) {
  const navigate = useNavigate();
  const isGames = title === 'Games Arcade';

  return (
    <div className={`demo-card ${isGames ? 'games-card' : ''}`} onClick={() => navigate(route)}>
      <div className="card-glow"></div>
      {isGames && (
        <div className="games-bg-emojis">
          <span className="games-float" style={{ '--d': '0s', '--x': '5%', '--y': '20%' }}>🎮</span>
          <span className="games-float" style={{ '--d': '0.5s', '--x': '25%', '--y': '60%' }}>🐍</span>
          <span className="games-float" style={{ '--d': '1s', '--x': '50%', '--y': '15%' }}>🧩</span>
          <span className="games-float" style={{ '--d': '1.5s', '--x': '75%', '--y': '55%' }}>❌</span>
          <span className="games-float" style={{ '--d': '0.8s', '--x': '88%', '--y': '25%' }}>📝</span>
          <span className="games-float" style={{ '--d': '1.2s', '--x': '40%', '--y': '75%' }}>🃏</span>
          <span className="games-float" style={{ '--d': '1.8s', '--x': '65%', '--y': '85%' }}>🔢</span>
          <span className="games-float" style={{ '--d': '0.3s', '--x': '15%', '--y': '85%' }}>🏆</span>
        </div>
      )}
      <div className="card-content">
        <div className="card-header">
          <div className="card-icon">{icon}</div>
          {status && <span className={`card-status ${status}`}>{status}</span>}
        </div>
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
        <div className="card-tags">
          {tags && tags.map((tag, i) => (
            <span key={i} className="card-tag">{tag}</span>
          ))}
        </div>
        <div className="card-footer">
          <span className="card-cta">
            View Demo
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
}

export default DemoCard;
